import _toConsumableArray from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
import "core-js/modules/es6.array.reduce";
import _regeneratorRuntime from "/opt/build/repo/node_modules/@babel/runtime/regenerator";
import "regenerator-runtime/runtime";
import _classCallCheck from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/inherits";
import "core-js/modules/es6.promise";
import "core-js/modules/es6.object.to-string";

var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }

  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }

    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }

    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }

    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};

import { BaseDeliveryQueryService } from './base-delivery-query.service';
export var QueryService =
/*#__PURE__*/
function (_BaseDeliveryQuerySer) {
  _inherits(QueryService, _BaseDeliveryQuerySer);

  function QueryService(config, httpService, sdkInfo, mappingService) {
    _classCallCheck(this, QueryService);

    return _possibleConstructorReturn(this, _getPrototypeOf(QueryService).call(this, config, httpService, sdkInfo, mappingService));
  }
  /**
   * Gets single item from given url
   * @param url Url used to get single item
   * @param queryConfig Query configuration
   */


  _createClass(QueryService, [{
    key: "getSingleItemAsync",
    value: function getSingleItemAsync(url, queryConfig) {
      return __awaiter(this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee() {
        var response;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return this.getResponseAsync(url, queryConfig);

              case 2:
                response = _context.sent;
                return _context.abrupt("return", this.mapNetworkResponse(this.mappingService.viewContentItemResponse(response.data), response));

              case 4:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));
    }
    /**
     * Gets single feed response. Might not contain all items in your project.
     * @param url Url
     * @param queryConfig Query configuration
     */

  }, {
    key: "getItemsFeed",
    value: function getItemsFeed(url, queryConfig) {
      return __awaiter(this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee2() {
        var response;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return this.getResponseAsync(url, queryConfig);

              case 2:
                response = _context2.sent;
                return _context2.abrupt("return", this.mapNetworkResponse(this.mappingService.itemsFeedResponse(response.data), response));

              case 4:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));
    }
    /**
     * Gets multiple items from given url
     * @param url Url used to get multiple items
     * @param queryConfig Query configuration
     */

  }, {
    key: "getMultipleItems",
    value: function getMultipleItems(url, queryConfig) {
      return __awaiter(this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee3() {
        var response;
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.next = 2;
                return this.getResponseAsync(url, queryConfig);

              case 2:
                response = _context3.sent;
                return _context3.abrupt("return", this.mapNetworkResponse(this.mappingService.listContentItemsResponse(response.data), response));

              case 4:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));
    }
    /**
     * Gets single content type from given url
     * @param url Url used to get single type
     * @param queryConfig Query configuration
     */

  }, {
    key: "getSingleType",
    value: function getSingleType(url, queryConfig) {
      return __awaiter(this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee4() {
        var response;
        return _regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _context4.next = 2;
                return this.getResponseAsync(url, queryConfig);

              case 2:
                response = _context4.sent;
                return _context4.abrupt("return", this.mapNetworkResponse(this.mappingService.viewContentTypeResponse(response.data), response));

              case 4:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, this);
      }));
    }
    /**
     * Gets multiple content types from given url
     * @param url Url used to get multiple types
     * @param queryConfig Query configuration
     */

  }, {
    key: "getMultipleTypes",
    value: function getMultipleTypes(url, queryConfig) {
      return __awaiter(this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee5() {
        var response;
        return _regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                _context5.next = 2;
                return this.getResponseAsync(url, queryConfig);

              case 2:
                response = _context5.sent;
                return _context5.abrupt("return", this.mapNetworkResponse(this.mappingService.listContentTypesResponse(response.data), response));

              case 4:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, this);
      }));
    }
    /**
     * Initializes synchronization of changes in content items based on the specified parameters. After the initialization,
     * you'll get an X-Continuation token in the response.
     * Use the token to synchronize changes in the content items matching the initialization criteria.
     * @param url Url
     * @param queryConfig Query configuration
     */

  }, {
    key: "initializeSync",
    value: function initializeSync(url, queryConfig) {
      return __awaiter(this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee6() {
        var response;
        return _regeneratorRuntime.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                _context6.next = 2;
                return this.postResponseAsync(url, {}, queryConfig);

              case 2:
                response = _context6.sent;
                return _context6.abrupt("return", this.mapNetworkResponse(this.mappingService.initializeContentSync(response.data), response));

              case 4:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6, this);
      }));
    }
    /**
     * Retrieve a list of delta updates to recently changed content items in the specified project.
     * The types of items you get is determined by the X-Continuation token you use.
     * @param url Url used to get multiple types
     * @param queryConfig Query configuration
     */

  }, {
    key: "syncChanges",
    value: function syncChanges(url, queryConfig) {
      return __awaiter(this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee7() {
        var response;
        return _regeneratorRuntime.wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                _context7.next = 2;
                return this.getResponseAsync(url, queryConfig);

              case 2:
                response = _context7.sent;
                return _context7.abrupt("return", this.mapNetworkResponse(this.mappingService.syncChanges(response.data), response));

              case 4:
              case "end":
                return _context7.stop();
            }
          }
        }, _callee7, this);
      }));
    }
    /**
     * Gets languages
     * @param url Url
     * @param queryConfig Query configuration
     */

  }, {
    key: "getLanguages",
    value: function getLanguages(url, queryConfig) {
      return __awaiter(this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee8() {
        var response;
        return _regeneratorRuntime.wrap(function _callee8$(_context8) {
          while (1) {
            switch (_context8.prev = _context8.next) {
              case 0:
                _context8.next = 2;
                return this.getResponseAsync(url, queryConfig);

              case 2:
                response = _context8.sent;
                return _context8.abrupt("return", this.mapNetworkResponse(this.mappingService.listLanguagesResponse(response.data), response));

              case 4:
              case "end":
                return _context8.stop();
            }
          }
        }, _callee8, this);
      }));
    }
    /**
     * Gets single taxonomy from given url
     * @param url Url used to get single taxonomy
     * @param queryConfig Query configuration
     */

  }, {
    key: "getTaxonomy",
    value: function getTaxonomy(url, queryConfig) {
      return __awaiter(this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee9() {
        var response;
        return _regeneratorRuntime.wrap(function _callee9$(_context9) {
          while (1) {
            switch (_context9.prev = _context9.next) {
              case 0:
                _context9.next = 2;
                return this.getResponseAsync(url, queryConfig);

              case 2:
                response = _context9.sent;
                return _context9.abrupt("return", this.mapNetworkResponse(this.mappingService.viewTaxonomyResponse(response.data), response));

              case 4:
              case "end":
                return _context9.stop();
            }
          }
        }, _callee9, this);
      }));
    }
    /**
     * Gets multiple taxonomies from given url
     * @param url Url used to get multiple taxonomies
     * @param queryConfig Query configuration
     */

  }, {
    key: "getTaxonomies",
    value: function getTaxonomies(url, queryConfig) {
      return __awaiter(this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee10() {
        var response;
        return _regeneratorRuntime.wrap(function _callee10$(_context10) {
          while (1) {
            switch (_context10.prev = _context10.next) {
              case 0:
                _context10.next = 2;
                return this.getResponseAsync(url, queryConfig);

              case 2:
                response = _context10.sent;
                return _context10.abrupt("return", this.mapNetworkResponse(this.mappingService.listTaxonomiesResponse(response.data), response));

              case 4:
              case "end":
                return _context10.stop();
            }
          }
        }, _callee10, this);
      }));
    }
    /**
     * Gets single content type element from given url
     * @param url Url used to get single content type element
     * @param queryConfig Query configuration
     */

  }, {
    key: "getElementAsync",
    value: function getElementAsync(url, queryConfig) {
      return __awaiter(this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee11() {
        var response;
        return _regeneratorRuntime.wrap(function _callee11$(_context11) {
          while (1) {
            switch (_context11.prev = _context11.next) {
              case 0:
                _context11.next = 2;
                return this.getResponseAsync(url, queryConfig);

              case 2:
                response = _context11.sent;
                return _context11.abrupt("return", this.mapNetworkResponse(this.mappingService.viewContentTypeElementResponse(response.data), response));

              case 4:
              case "end":
                return _context11.stop();
            }
          }
        }, _callee11, this);
      }));
    }
  }, {
    key: "getListAllResponse",
    value: function getListAllResponse(data) {
      return __awaiter(this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee12() {
        var responses;
        return _regeneratorRuntime.wrap(function _callee12$(_context12) {
          while (1) {
            switch (_context12.prev = _context12.next) {
              case 0:
                _context12.next = 2;
                return this.getListAllResponseInternalAsync({
                  page: data.page,
                  resolvedResponses: [],
                  getResponse: data.getResponse,
                  nextPageUrl: undefined,
                  continuationToken: undefined,
                  listQueryConfig: data.listQueryConfig
                });

              case 2:
                responses = _context12.sent;
                return _context12.abrupt("return", data.allResponseFactory(responses.reduce(function (prev, current) {
                  prev.push.apply(prev, _toConsumableArray(current.data.items));
                  return prev;
                }, []), responses));

              case 4:
              case "end":
                return _context12.stop();
            }
          }
        }, _callee12, this);
      }));
    }
  }, {
    key: "getListAllResponseInternalAsync",
    value: function getListAllResponseInternalAsync(data) {
      var _a, _b, _c, _d;

      return __awaiter(this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee13() {
        var response, nextPage, continuationToken;
        return _regeneratorRuntime.wrap(function _callee13$(_context13) {
          while (1) {
            switch (_context13.prev = _context13.next) {
              case 0:
                if (!((_a = data.listQueryConfig) === null || _a === void 0 ? void 0 : _a.pages)) {
                  _context13.next = 3;
                  break;
                }

                if (!(data.page > data.listQueryConfig.pages)) {
                  _context13.next = 3;
                  break;
                }

                return _context13.abrupt("return", data.resolvedResponses);

              case 3:
                _context13.next = 5;
                return data.getResponse(data.nextPageUrl, data.continuationToken);

              case 5:
                response = _context13.sent;

                if (!((_b = data.listQueryConfig) === null || _b === void 0 ? void 0 : _b.delayBetweenRequests)) {
                  _context13.next = 9;
                  break;
                }

                _context13.next = 9;
                return this.sleep(data.listQueryConfig.delayBetweenRequests);

              case 9:
                data.resolvedResponses.push(response);

                if ((_c = data.listQueryConfig) === null || _c === void 0 ? void 0 : _c.responseFetched) {
                  data.listQueryConfig.responseFetched(response, data.nextPageUrl, data.continuationToken);
                }

                nextPage = (_d = response.data.pagination) === null || _d === void 0 ? void 0 : _d.nextPage;
                continuationToken = response.xContinuationToken;

                if (!(nextPage || continuationToken)) {
                  _context13.next = 17;
                  break;
                }

                _context13.next = 16;
                return this.getListAllResponseInternalAsync({
                  page: data.page + 1,
                  nextPageUrl: nextPage,
                  continuationToken: continuationToken,
                  listQueryConfig: data.listQueryConfig,
                  getResponse: data.getResponse,
                  resolvedResponses: data.resolvedResponses
                });

              case 16:
                return _context13.abrupt("return", _context13.sent);

              case 17:
                return _context13.abrupt("return", data.resolvedResponses);

              case 18:
              case "end":
                return _context13.stop();
            }
          }
        }, _callee13, this);
      }));
    }
  }, {
    key: "sleep",
    value: function sleep(ms) {
      return new Promise(function (resolve) {
        return setTimeout(resolve, ms);
      });
    }
  }]);

  return QueryService;
}(BaseDeliveryQueryService);